<template>
    <form-section
        id="insurance"
        method="patch"
        :url="url"
        :read_only="read_only"
    >
        <insurance-primary
            :insurance="property.insurance"
            :has_coverage="has_coverage"
            :available_contacts="available_contacts"
            :read_only="read_only"
            @updateHasCoverage="updateHasCoverage"
        />

        <insurance-multiple
            v-if="property.is_commercial && has_coverage"
            :other_insurance_policies="property.insurance.other_insurance_policies"
            :read_only="read_only"
        />
    </form-section>
</template>

<script>
import FormSection from '../../components/form-section.vue';
import InsurancePrimary from './insurance-primary.vue';
import InsuranceMultiple from './insurance-multiple.vue';

export default {
    components: {
        FormSection,
        InsurancePrimary,
        InsuranceMultiple,
    },

    props: {
        property: {},
        url: {},
        read_only: { default: false },
        available_contacts: { default: () => [] },
    },

    data() {
        return {
            has_coverage: this.property.insurance.has_coverage,
        }
    },

    methods: {
        updateHasCoverage(value) {
            this.has_coverage = value;
        },
    },
}
</script>
